import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as ArrowLeftTest } from '../assets/arrow-left-testimonial.svg';
import { ReactComponent as ArrowRightTest } from '../assets/arrow-right-testimonial.svg';
import { ReactComponent as ArrowRight } from '../assets/arrow-right.svg';
import artist from '../assets/artist.png';
import cakeSweets from '../assets/cake-sweets.jpg';
import caterer from '../assets/caterer.png';
import contactEmail from '../assets/contact-email.svg';
import contactIllustration from '../assets/contact-figure.svg';
import contactPhone from '../assets/contact-phone.svg';
import groomBride from '../assets/groomBride.jpg';
import how1 from '../assets/how1.png';
import how2 from '../assets/how2.png';
import how3 from '../assets/how3.png';
import locationIcon from '../assets/location-icon.svg';
import ovalHall from '../assets/Oval-Hall.jpg';
import sampleLogo from '../assets/sample-logo.svg';
import videography from '../assets/videography.jpg';
import Footer from './partials/Footer';
import Header from './partials/Header';
import styles from './styles/HomePage.module.scss';

const REVIEWS_COUNT = 3;

const HomePage = () => {
  const [t] = useTranslation('common');
  const [currentReview, setCurrentReview] = React.useState(1);

  const changeSlide = (num: number) => {
    if (num > REVIEWS_COUNT || num < 1) {
      return;
    }
    document.querySelectorAll(`.${styles.testimonial}`).forEach((item: any) => {
      item.style.display = 'none';
      item.classList.remove(styles.withAnimation);
    });

    const el = document.querySelector(`#review${num}`) as HTMLDivElement;
    el.style.display = 'flex';
    el.classList.add(styles.withAnimation);

    setCurrentReview(num);
  };
  const prevSlide = (e: any) => {
    e.preventDefault();
    changeSlide(currentReview - 1);
  };
  const nextSlide = (e: any) => {
    e.preventDefault();
    changeSlide(currentReview + 1);
  };
  const isFirstSlide = () => currentReview === 1;
  const isLastSlide = () => currentReview === REVIEWS_COUNT;

  React.useEffect(() => {
    [2, 3].forEach((n: number, i) => {
      (document.querySelector(`#review${n}`) as HTMLElement).style.display = 'none';
    });
  }, []);

  return (
    <main className={styles.container}>
      <div className={styles.headerContainer}>
        <Header isLandingPage />
        <div className={styles.bannerContainer}>
          <div className={styles.banner}>
            <h2 className={styles.text1}>{t('letsCelebrate')}</h2>
            <h6 className={styles.text2}>Lorem ipsum dolor sit amet.</h6>
            <Link to={'signup'} className={styles.ctaBtnHeader}>
              {t('getStarted')}
            </Link>
            <div className={styles.logos}>
              <svg xmlns="http://www.w3.org/2000/svg" width="469" height="84" viewBox="0 0 469 84">
                <g id="Group_77" data-name="Group 77" transform="translate(-129 -672)">
                  <path
                    id="icons8_dev_post"
                    d="M16.086,7,3.852,28.839,16.4,50.669H42.925l12.23-21.835L42.925,7Zm4.928,9.7H29.7a12.132,12.132,0,0,1,0,24.261H21.014Zm4.852,4.852V36.113h3.639a7.278,7.278,0,1,0,0-14.556Z"
                    transform="translate(132.148 671.065)"
                    fill="#9676cf"
                  />
                  <path
                    id="icons8_jquery"
                    d="M35.59,3.01a1.393,1.393,0,0,0-.379.114,9.231,9.231,0,0,0-2.454,2.355.386.386,0,0,0-.038.057,10.876,10.876,0,0,0-1.82,5.942,11.98,11.98,0,0,0,.933,4.719,14.567,14.567,0,0,0,8.2,7.861c.123.043.242.085.455.161.019.009.2.066.227.071l.133.047a5.2,5.2,0,0,0,.573.161,16.878,16.878,0,0,0,2.781.332c.152,0,.3,0,.455,0A10.925,10.925,0,0,0,54.743,18.58a3.969,3.969,0,0,1,.2-.351s0,0,0-.009a1.212,1.212,0,1,0-2-1.365h0c-1.772,2.611-4.8,3.4-9.008,2.36a8.666,8.666,0,0,1-.957-.308,11.584,11.584,0,0,1-1.166-.488,12.356,12.356,0,0,1-2.052-1.284c-3.7-2.867-5.141-8.832-2.98-12.277A1.214,1.214,0,0,0,35.59,3.01ZM24.843,5.426a1.187,1.187,0,0,0-.782.275,28.739,28.739,0,0,0-3.791,4.037.312.312,0,0,1-.033.052c-3.317,4.828-3.568,11.7-.635,17.5a21.839,21.839,0,0,0,1.535,2.6l.166.237A11.309,11.309,0,0,0,22.971,32.2c.232.265.483.521.73.768l.119.123.1.1c.251.242.507.488.772.725h0a.511.511,0,0,0,.071.071c.3.265.6.517,1,.834l.109.081c.313.251.63.488.957.72l.1.071c.114.076.227.147.341.227l.114.076.133.085c.242.161.479.308.815.5.218.133.45.265.6.341.066.038.137.076.3.166l.37.194.123.057c.242.123.493.242.744.355l.384.171c.251.109.507.213.82.332l.142.052c.009.009.128.052.137.057.227.081.46.161.692.237l.531.175a5.84,5.84,0,0,0,.91.251,29.314,29.314,0,0,0,4.781.417c.18,0,.36,0,.535,0A17.734,17.734,0,0,0,56.321,27.6a1.212,1.212,0,0,0-2.165-1.024c-3.393,4.956-9.809,7.051-16.343,5.326-.3-.076-.6-.161-.962-.279-.062-.019-.114-.038-.213-.076-.213-.066-.422-.137-.659-.227l-.336-.128c-.194-.076-.389-.152-.626-.256l-.156-.071c-.289-.123-.569-.261-.82-.384l-.692-.36c-.156-.076-.294-.161-.507-.289l-.119-.066L32.6,29.7c-.175-.1-.351-.213-.512-.327l-.114-.071c-.009,0-.1-.071-.114-.081-.142-.09-.28-.18-.412-.265-.294-.208-.583-.426-.919-.692l-.133-.109a19.48,19.48,0,0,1-6.525-9.411c-1.009-3.284-.261-7.582,2-11.5a1.207,1.207,0,0,0-.265-1.531A1.194,1.194,0,0,0,24.843,5.426ZM11.5,9.065a1.221,1.221,0,0,0-.815.313,26.626,26.626,0,0,0-4.241,5.084c-4.956,7.217-4,18.432-.6,25.289.066.142.137.279.208.417l.047.076a2.4,2.4,0,0,0,.156.308,1.17,1.17,0,0,0,.118.218c.057.119.114.223.218.4l.389.668c.057.09.114.185.133.218.076.123.156.251.237.379l.19.3a2.64,2.64,0,0,0,.152.218c.19.294.379.588.588.867a.207.207,0,0,0,.028.033l.076.1c.171.246.346.483.5.678l.692.877c.009.009.085.1.09.109l.1.114c.208.256.431.512.654.758.033.038.066.071.1.109.213.232.431.464.659.706l.218.208c.18.19.36.374.55.55,0,0,.09.09.09.09l.19.175c.227.218.464.436.644.588.009.014.18.161.194.171.223.2.445.389.673.573l1.161.919c.194.142.393.284.621.45.076.057.156.114.237.166a.818.818,0,0,0,.095.071l.872.583c.317.209.635.4,1.024.635l.208.118c.242.142.488.284.72.408.137.076.275.142.393.2.166.09.346.19.621.322.024.014.218.109.242.118.275.137.554.265.905.422,0,0,.114.057.114.057.322.137.635.27,1.047.436.066.029.133.052.147.057.294.114.6.227.853.317l.175.071c.336.114.668.223,1.095.355.071.024.147.047.156.047l.242.076a8.733,8.733,0,0,0,.905.246,36.6,36.6,0,0,0,6.544.625h0c17.376,0,22.91-13.983,22.967-14.125a1.215,1.215,0,0,0-2.1-1.166c-4.459,5.871-12.869,8.051-22.5,5.838-.232-.057-.469-.123-.7-.194l-.455-.137c-.308-.095-.616-.2-.915-.3,0,0-.142-.052-.142-.052-.265-.09-.531-.194-.763-.284l-.265-.1c-.294-.118-.588-.242-.872-.37L26.2,45.4c-.256-.118-.5-.232-.749-.355-.019-.009-.213-.1-.232-.109-.171-.085-.341-.175-.559-.294l-.99-.531a3.416,3.416,0,0,0-.3-.18c-.3-.185-.607-.37-.91-.564-.071-.043-.133-.09-.251-.171-.208-.133-.412-.27-.711-.479l-.119-.085c-.2-.142-.4-.294-.569-.417-.1-.076-.209-.161-.379-.289-.152-.119-.3-.232-.445-.346l-.265-.218c-.223-.18-.431-.37-.649-.554a.609.609,0,0,0-.085-.071c-.242-.223-.488-.445-.782-.725l-.858-.853c-.208-.213-.417-.431-.654-.692-.218-.242-.427-.483-.706-.815l-.512-.625a3.265,3.265,0,0,0-.209-.275c-.175-.237-.351-.469-.526-.715C10.021,29.54,8.789,15.969,12.466,11A1.212,1.212,0,0,0,11.5,9.065Z"
                    transform="translate(231.809 669.001)"
                    fill="#9676cf"
                  />
                  <path
                    id="icons8_github_1"
                    d="M21.155,56.388a2.425,2.425,0,0,0,1.467-2.227V47.61a6.248,6.248,0,0,1,.05-.74l-.05.012H18.255A4.369,4.369,0,0,1,14.13,44.7c-.849-1.577-1.213-4.246-3.4-5.7-.364-.243-.121-.607.607-.607a6.644,6.644,0,0,1,3.275,2.426c1.092,1.334,2.183,2.426,4.124,2.426,3.017,0,4.634-.152,5.607-.673,1.133-1.685,2.7-2.966,4.34-2.966v-.03c-6.876-.221-11.268-2.506-13.313-6.035A73.209,73.209,0,0,0,4.848,34.4q-.106-.595-.183-1.2a74.311,74.311,0,0,1,10.123-.866,9.9,9.9,0,0,1-.353-1.03,78.391,78.391,0,0,0-9.931.118c-.024-.4-.057-.8-.062-1.212a79.477,79.477,0,0,1,9.726-.135A11.926,11.926,0,0,1,14.01,28.2a10.444,10.444,0,0,1,2.062-6.065c-.607-2.062-1.456-6.429.243-8.006a10.1,10.1,0,0,1,6.672,2.547A17.977,17.977,0,0,1,29.9,15.343a16.956,16.956,0,0,1,6.793,1.334,10.1,10.1,0,0,1,6.672-2.547c1.82,1.7.849,6.065.243,8.006A9.308,9.308,0,0,1,45.548,28.2a12.1,12.1,0,0,1-.133,1.709,80.13,80.13,0,0,1,9.952.124c0,.409-.04.808-.062,1.212a78.592,78.592,0,0,0-10.14-.108,10.034,10.034,0,0,1-.394,1.189,75.4,75.4,0,0,1,10.369.836q-.078.6-.183,1.2a73.927,73.927,0,0,0-10.771-.827c-2.02,3.491-6.332,5.768-13.073,6.034V39.6c3.154,0,6.065,4.731,6.065,8.006v6.55a2.425,2.425,0,0,0,1.467,2.227,27.9,27.9,0,1,0-17.49,0Z"
                    transform="translate(333.292 670)"
                    fill="#9676cf"
                  />
                  <path
                    id="icons8_codepen"
                    d="M29.474,4,4,20.187v18.57L29.474,54.948,54.948,38.761V20.187Zm0,30.549-7.2-4.99,7.2-4.909,7.2,4.909ZM31.9,20.5V11.217L48.191,21.57l-7.3,5.061Zm-4.852,0-8.989,6.127-7.3-5.061L27.048,11.217Zm-13.23,9.022L8.852,32.909V26.081Zm4.217,2.924,9.013,6.25v9.031L10.781,37.392ZM31.9,38.7l9.013-6.25,7.255,4.942L31.9,47.731Zm13.23-9.174L50.1,26.081v6.828Z"
                    transform="translate(434.573 670.426)"
                    fill="#9676cf"
                  />
                  <path
                    id="icons8_git"
                    d="M56.336,26.37,33.43,3.464a4.988,4.988,0,0,0-7.06,0l-4.53,4.53L27.445,13.6a4.83,4.83,0,0,1,6.62,6.62l5.511,5.511a4.852,4.852,0,1,1-1.715,1.715L32.35,21.935a4.678,4.678,0,0,1-1.237.512v14.9a4.852,4.852,0,1,1-2.426,0v-14.9a4.8,4.8,0,0,1-2.952-7.127l-5.61-5.61L3.464,26.37a4.988,4.988,0,0,0,0,7.06L26.37,56.336a4.988,4.988,0,0,0,7.06,0L56.336,33.43A4.988,4.988,0,0,0,56.336,26.37Z"
                    transform="translate(534.5 670)"
                    fill="#9676cf"
                  />
                  <text id="Dummy" transform="translate(162 750)" fill="#a7a7a7" fontSize="16" fontFamily="Poppins-Medium, Poppins" fontWeight="500">
                    <tspan x="-32.144" y="0">
                      Dummy
                    </tspan>
                  </text>
                  <text
                    id="Dummy-2"
                    data-name="Dummy"
                    transform="translate(261 750)"
                    fill="#a7a7a7"
                    fontSize="16"
                    fontFamily="Poppins-Medium, Poppins"
                    fontWeight="500"
                  >
                    <tspan x="-32.144" y="0">
                      Dummy
                    </tspan>
                  </text>
                  <text
                    id="Dummy-3"
                    data-name="Dummy"
                    transform="translate(360 750)"
                    fill="#a7a7a7"
                    fontSize="16"
                    fontFamily="Poppins-Medium, Poppins"
                    fontWeight="500"
                  >
                    <tspan x="-32.144" y="0">
                      Dummy
                    </tspan>
                  </text>
                  <text
                    id="Dummy-4"
                    data-name="Dummy"
                    transform="translate(463 750)"
                    fill="#a7a7a7"
                    fontSize="16"
                    fontFamily="Poppins-Medium, Poppins"
                    fontWeight="500"
                  >
                    <tspan x="-32.144" y="0">
                      Dummy
                    </tspan>
                  </text>
                  <text
                    id="Dummy-5"
                    data-name="Dummy"
                    transform="translate(565 750)"
                    fill="#a7a7a7"
                    fontSize="16"
                    fontFamily="Poppins-Medium, Poppins"
                    fontWeight="500"
                  >
                    <tspan x="-32.144" y="0">
                      Dummy
                    </tspan>
                  </text>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <section className={styles.sectionEvents}>
        <div className="containerFixed">
          <h1 className="title">What are looking for?</h1>
          <div className={styles.search}>
            <input type="text" name="search" placeholder="Search" />
          </div>
          <div className={styles.items}>
            <div className={styles.item}>
              <div className={styles.img}>
                <img src={ovalHall} alt="" />
              </div>
              <div className={styles.details}>
                <h6>Venues</h6>
                <p>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed.</p>
                <div className={styles.info}>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>697 South Gonzales Lane Severn, MD 2</span>
                  </div>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>09:00 AM to 02:00 PM</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.item}>
              <div className={styles.img}>
                <img src={videography} alt="" />
              </div>
              <div className={styles.details}>
                <h6>Videography</h6>
                <p>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed.</p>
                <div className={styles.info}>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>697 South Gonzales Lane Severn, MD 2</span>
                  </div>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>09:00 AM to 02:00 PM</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.item}>
              <div className={styles.img}>
                <img src={artist} alt="" />
              </div>
              <div className={styles.details}>
                <h6>Artists</h6>
                <p>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed.</p>
                <div className={styles.info}>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>697 South Gonzales Lane Severn, MD 2</span>
                  </div>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>09:00 AM to 02:00 PM</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.img}>
                <img src={caterer} alt="" />
              </div>
              <div className={styles.details}>
                <h6>Caterer</h6>
                <p>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed.</p>
                <div className={styles.info}>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>697 South Gonzales Lane Severn, MD 2</span>
                  </div>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>09:00 AM to 02:00 PM</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.img}>
                <img src={cakeSweets} alt="" />
              </div>
              <div className={styles.details}>
                <h6>Cakes And Sweets</h6>
                <p>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed.</p>
                <div className={styles.info}>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>697 South Gonzales Lane Severn, MD 2</span>
                  </div>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>09:00 AM to 02:00 PM</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.item}>
              <div className={styles.img}>
                <img src={groomBride} alt="" />
              </div>
              <div className={styles.details}>
                <h6>Groom &amp; Bride Dresses</h6>
                <p>Lorem Ipsum Dolor Sit Amet, Consetetur Sadipscing Elitr, Sed.</p>
                <div className={styles.info}>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>697 South Gonzales Lane Severn, MD 2</span>
                  </div>
                  <div>
                    <img src={locationIcon} alt="" />
                    <span>09:00 AM to 02:00 PM</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.sectionHowItWorks}>
        <div className="containerFixed">
          <h1 className="title">How it works</h1>
          <div className={styles.steps}>
            <div className={styles.step}>
              <img src={how1} alt="" />
              <h2>Step 1</h2>
              <p>Event Management Registration</p>
              <ArrowRight className={styles.arrow} />
            </div>
            <div className={styles.step}>
              <img src={how2} alt="" />
              <h2>Step 2</h2>
              <p>Connect with your target audience at the right time</p>
              <ArrowRight className={styles.arrow} />
            </div>
            <div className={styles.step}>
              <img src={how3} alt="" />
              <h2>Step 3</h2>
              <p>Track Booking and Payment</p>
            </div>
          </div>
          <a href="#want-to-learn-more" className={styles.ctaBtnHowItWorks}>
            Want to learn more
          </a>
        </div>
      </div>
      <section className={styles.sectionTestimonials}>
        <div className="containerFixed">
          <h1 className="title">Testimonials</h1>
          <button disabled={isFirstSlide()} onClick={(e) => prevSlide(e)} className={[styles.arrowButton, styles.left].join(' ')}>
            <ArrowLeftTest />
          </button>
          <button disabled={isLastSlide()} onClick={(e) => nextSlide(e)} className={[styles.arrowButton, styles.right].join(' ')}>
            <ArrowRightTest />
          </button>
          <div className={styles.testimonials}>
            <div id="review1" className={styles.testimonial}>
              <div className={styles.content}>
                <div className={styles.details}>
                  <img className={styles.photo} src="https://i.pravatar.cc/150?u=a042581f4e2900" alt="" />
                  <div className={styles.name}>
                    <h6>Person A</h6>
                    <span>CEO at company</span>
                  </div>
                  <img className={styles.logo} src={sampleLogo} alt="" />
                </div>
                <div className={styles.review}>
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                    erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
                    sanctus est Lorem sanctus est Lorem
                  </p>
                </div>
              </div>
            </div>
            <div id="review2" className={styles.testimonial}>
              <div className={styles.content}>
                <div className={styles.details}>
                  <img className={styles.photo} src="https://i.pravatar.cc/150?u=a042581f4e900" alt="" />
                  <div className={styles.name}>
                    <h6>Person B</h6>
                    <span>CEO at company</span>
                  </div>
                  <img className={styles.logo} src={sampleLogo} alt="" />
                </div>
                <div className={styles.review}>
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                    erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
                    sanctus est Lorem sanctus est Lorem
                  </p>
                </div>
              </div>
            </div>
            <div id="review3" className={styles.testimonial}>
              <div className={styles.content}>
                <div className={styles.details}>
                  <img className={styles.photo} src="https://i.pravatar.cc/150?u=a042581f4s900" alt="" />
                  <div className={styles.name}>
                    <h6>Person C</h6>
                    <span>CEO at company</span>
                  </div>
                  <img className={styles.logo} src={sampleLogo} alt="" />
                </div>
                <div className={styles.review}>
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
                    erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
                    sanctus est Lorem sanctus est Lorem
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.sectionContact}>
        <div className="containerFixed">
          <h1 className="title">Get in touch with us</h1>
          <div className={styles.contact}>
            <img src={contactIllustration} alt="contact" />
            <div className={styles.details}>
              <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy</p>
              <div className={styles.contactInfo}>
                <img src={contactPhone} alt="phone" />
                <span> +49-17620652337</span>
              </div>
              <div className={styles.contactInfo}>
                <img src={contactEmail} alt="email" />
                <span> support@stargid.com</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default HomePage;
